// Email Validation for Gift Recipient
document.addEventListener("DOMContentLoaded", function () {
  function log(...args) {
    console.log("CUSTOM EMAIL VALIDATION -", ...args);
  }

  log("init");
  // Do not change the apostrophe in this string - it must match the label exactly
  const EMAIL_LABEL = "Your gift recipient’s email";
  const ADDITIONAL_STORYTELLER_LABEL =
    "Would you like to add an additional storyteller to contribute to the same book (ex: Mom & Dad book) for $50 extra?";
  const ADDITIONAL_STORYTELLER_VALUE = "1 Additional Storyteller";
  const WHO_TELLING_STORIES_PROPERTY = "Who will be telling stories?";
  const WHO_TELLING_STORIES_SOMEONE_ELSE = "Someone Else";
  // Zod's email regex - strict validation similar to Gmail rules
  // Source: https://colinhacks.com/essays/reasonable-email-regex
  const emailRegex =
    /^(?!\.)(?!.*\.\.)([a-z0-9_'+\-\.]*)[a-z0-9_+-]@([a-z0-9][a-z0-9\-]*\.)+[a-z]{2,}$/i;

  // Check if "Someone Else" is selected for who will be telling stories
  function isSomeoneElseSelected() {
    const input = /** @type {HTMLInputElement|null} */ (
      document.querySelector(
        `input[name="properties[${WHO_TELLING_STORIES_PROPERTY}]"]`,
      )
    );
    const isSelected = input?.value === WHO_TELLING_STORIES_SOMEONE_ELSE;
    log("someone else selected:", isSelected);
    return isSelected;
  }

  // Find gift recipient email input by exact label name
  function getGiftRecipientEmailInput() {
    const labels = document.querySelectorAll(".tcustomizer-field__heading");
    log("getGiftRecipientEmailInput - labels", labels);
    for (const label of labels) {
      if (label.textContent.trim().replace("*", "").trim() === EMAIL_LABEL) {
        const field = label.closest(".tcustomizer-field");
        const input = field?.querySelector(".tcustomizer__text-field");
        log("gift recipient input found:", !!input);
        return input;
      }
    }
    log("gift recipient input not found");
    return null;
  }

  // Check if additional storyteller option is selected
  function isAdditionalStorytellerSelected() {
    // Find label by text, then get its container and select
    const labels = document.querySelectorAll("label.form__label");
    for (const label of labels) {
      if (label.textContent.trim() === ADDITIONAL_STORYTELLER_LABEL) {
        const container = label.closest(".product-form__input");
        if (!container) {
          log("dropdown container not found");
          return false;
        }
        const select = container.querySelector("select");
        if (!select) {
          log("select not found");
          return false;
        }
        const isSelected = select.value === ADDITIONAL_STORYTELLER_VALUE;
        log("additional storyteller selected:", isSelected);
        return isSelected;
      }
    }
    log("additional storyteller label not found");
    return false;
  }

  // Find additional storyteller fields (visible one only)
  function getStorytellerFields() {
    const container = document.querySelector(".additional-storytellers-fields");
    if (!container) {
      log("storyteller container not found");
      return null;
    }
    // Find visible storyteller field (not display: none)
    const storytellerFields = container.querySelectorAll(".storyteller-field");
    for (const field of storytellerFields) {
      if (field.style.display !== "none") {
        const nameInput = field.querySelector('input[type="text"]');
        const emailInput = field.querySelector('input[type="email"]');
        log(
          "storyteller fields found - name:",
          !!nameInput,
          "email:",
          !!emailInput,
        );
        return { nameInput, emailInput };
      }
    }
    log("storyteller fields not found");
    return null;
  }

  function showError(message) {
    log("showing error");
    const errorDiv = document.createElement("div");
    errorDiv.className = "email-validation-error";
    errorDiv.style.cssText = "color:#d32f2f;font-size:14px;margin-bottom:10px;";
    errorDiv.textContent = message;
    const buttonsContainer = document.querySelector(".product-form__buttons");
    if (buttonsContainer) {
      buttonsContainer.insertBefore(errorDiv, buttonsContainer.firstChild);
    }
  }

  function removeErrors() {
    const errors = document.querySelectorAll(".email-validation-error");
    errors.forEach((error) => error.remove());
  }

  function validateEmail(input, fieldName) {
    if (!input) return true;
    const value = input.value.trim();
    if (value === "") {
      log(fieldName + " empty, skipping");
      return true;
    }
    if (!emailRegex.test(value)) {
      log(fieldName + " invalid email");
      showError("Please enter a valid email address for " + fieldName);
      return false;
    }
    log(fieldName + " valid");
    return true;
  }

  function validateRequired(input, fieldName) {
    if (!input) return true;
    const value = input.value.trim();
    if (value === "") {
      log(fieldName + " is required");
      showError(fieldName + " is required");
      return false;
    }
    log(fieldName + " has value");
    return true;
  }

  function validate() {
    log("validating");
    removeErrors();

    const someoneElse = isSomeoneElseSelected();
    const additionalStoryteller = isAdditionalStorytellerSelected();

    // Validate gift recipient email only if "Someone Else" is selected
    if (someoneElse) {
      const giftInput = getGiftRecipientEmailInput();
      if (!validateEmail(giftInput, "gift recipient")) {
        return false;
      }
    }

    // Validate storyteller fields if additional storyteller is selected
    if (additionalStoryteller) {
      const storytellerFields = getStorytellerFields();
      if (storytellerFields) {
        // Validate name is required
        if (
          !validateRequired(storytellerFields.nameInput, "Storyteller name")
        ) {
          return false;
        }
        // Validate email is required and valid format
        if (
          !validateRequired(storytellerFields.emailInput, "Storyteller email")
        ) {
          return false;
        }
        if (!validateEmail(storytellerFields.emailInput, "the storyteller")) {
          return false;
        }
      }
    }

    // Validate emails are different when both fields are active
    if (someoneElse && additionalStoryteller) {
      const giftInput = /** @type {HTMLInputElement|null} */ (
        getGiftRecipientEmailInput()
      );
      const storytellerFields = getStorytellerFields();
      const storytellerEmailInput = /** @type {HTMLInputElement|null} */ (
        storytellerFields?.emailInput
      );
      const giftEmail = giftInput?.value?.trim().toLowerCase();
      const storytellerEmail = storytellerEmailInput?.value
        ?.trim()
        .toLowerCase();

      if (giftEmail && storytellerEmail && giftEmail === storytellerEmail) {
        log("duplicate emails detected");
        showError(
          "Gift recipient email and storyteller email must be different",
        );
        return false;
      }
    }

    return true;
  }

  // Use event delegation to handle button clicks (button may be replaced by Tepo)
  document.addEventListener(
    "click",
    function (e) {
      const target = /** @type {HTMLElement} */ (e.target);
      if (target && target.closest("#tcustomizer-add")) {
        log("button clicked");
        if (!validate()) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    },
    true,
  ); // capture phase - runs before theme's JS
});
